import analytics from 'scripts/lib/analytics';
import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';

export default class ToggleFavoriteAnswer {
  constructor(context) {
    this.context = context;
  }

  run({ answer }) {
    const isFavorited = this.context.stores.favoriteAnswers.has({ id: answer.id });

    const agentPreferences = this.context.stores.agentPreferences.get();
    agentPreferences.toggleFavoriteAnswer(answer.id);
    setAgentPreferences(this.context, agentPreferences);

    if (this._isBackendPersistenceEnabled()) {
      if (isFavorited) {
        const record = this.context.stores.favoriteAnswerRecords.findBy({ answerId: answer.id });
        this.context.stores.favoriteAnswers.remove(answer.id);
        this.context.stores.favoriteAnswerRecords.remove(answer.id);
        this.context.gateways.favoriteAnswers.delete({ answerId: answer.id }).catch(() => {
          this.context.stores.favoriteAnswers.addOrReplace(answer);
          if (record) {
            this.context.stores.favoriteAnswerRecords.addOrReplace(record);
          }
        });
      } else {
        this.context.stores.favoriteAnswers.addOrReplace(answer);
        this.context.gateways.favoriteAnswers.add({ answerId: answer.id }).catch(() => {
          this.context.stores.favoriteAnswers.remove(answer.id);
        });
      }
    } else {
      if (!isFavorited) {
        this.context.stores.favoriteAnswers.addOrReplace(answer);
      } else {
        this.context.stores.favoriteAnswers.remove(answer.id);
      }
    }

    analytics.track('Answer Favorites Changed', {
      numFavorites: this.context.stores.favoriteAnswers.count(),
    });
  }

  _isBackendPersistenceEnabled() {
    return this.context.stores.appFeatures.get().isEnabled('favoriteAnswersPersistence');
  }
}
